export default __webpack_public_path__ + "static/media/dry_needling_intake.d08e9d15.pdf";